import { create } from "zustand";
import { persist } from "zustand/middleware";

interface UiState {
  workspace: string;
  theme: "dark" | "light";
  density: "default" | "compact" | "comfortable";
  selected: { type: string; id: string } | null;
  panelCollapsed: Record<string, boolean>;

  setWorkspace: (workspace: string) => void;
  setTheme: (theme: "dark" | "light") => void;
  setDensity: (density: "default" | "compact" | "comfortable") => void;
  setSelected: (selected: { type: string; id: string } | null) => void;
  togglePanel: (panelId: string) => void;
}

export const useUiStore = create<UiState>()(
  persist(
    (set) => ({
      workspace: "operations",
      theme: "dark",
      density: "default",
      selected: null,
      panelCollapsed: {},

      setWorkspace: (workspace) => set({ workspace }),

      setTheme: (theme) => {
        document.documentElement.setAttribute("data-theme", theme);
        localStorage.setItem("dw-theme", theme);
        set({ theme });
      },

      setDensity: (density) => set({ density }),

      setSelected: (selected) => set({ selected }),

      togglePanel: (panelId) =>
        set((state) => ({
          panelCollapsed: {
            ...state.panelCollapsed,
            [panelId]: !state.panelCollapsed[panelId],
          },
        })),
    }),
    {
      name: "rc-ui-store",
      partialize: (state) => ({
        theme: state.theme,
        density: state.density,
        panelCollapsed: state.panelCollapsed,
      }),
    },
  ),
);
